import * as React from 'react';
import ReactCountryFlag from 'react-country-flag';

const fontSize = '2em';
const lineHeight = '2em';

export const OHADA_COUNTRIES = [
  {
    value: 'BEN',
    text: 'countries.bj',
    icon: (
      <ReactCountryFlag
        countryCode="bj"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'BFA',
    text: 'countries.bf',
    icon: (
      <ReactCountryFlag
        countryCode="bf"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'CMR',
    text: 'countries.cm',
    icon: (
      <ReactCountryFlag
        countryCode="cm"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'COM',
    text: 'countries.km',
    icon: (
      <ReactCountryFlag
        countryCode="km"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'COG',
    text: 'countries.cg',
    icon: (
      <ReactCountryFlag
        countryCode="cg"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'COD',
    text: 'countries.cd',
    icon: (
      <ReactCountryFlag
        countryCode="cd"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'CIV',
    text: 'countries.ci',
    icon: (
      <ReactCountryFlag
        countryCode="ci"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'GAB',
    text: 'countries.ga',
    icon: (
      <ReactCountryFlag
        countryCode="ga"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'GIN',
    text: 'countries.gn',
    icon: (
      <ReactCountryFlag
        countryCode="gn"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'GNB',
    text: 'countries.gw',
    icon: (
      <ReactCountryFlag
        countryCode="gw"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'GNQ',
    text: 'countries.gq',
    icon: (
      <ReactCountryFlag
        countryCode="gq"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'MLI',
    text: 'countries.ml',
    icon: (
      <ReactCountryFlag
        countryCode="ml"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'NER',
    text: 'countries.ne',
    icon: (
      <ReactCountryFlag
        countryCode="ne"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'CAF',
    text: 'countries.cf',
    icon: (
      <ReactCountryFlag
        countryCode="cf"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'SEN',
    text: 'countries.sn',
    icon: (
      <ReactCountryFlag
        countryCode="sn"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'TCD',
    text: 'countries.td',
    icon: (
      <ReactCountryFlag
        countryCode="td"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
  {
    value: 'TGO',
    text: 'countries.tg',
    icon: (
      <ReactCountryFlag
        countryCode="tg"
        style={{
          fontSize,
          lineHeight,
        }}
        svg
      />
    ),
  },
];
